import { toPng, toSvg } from 'html-to-image';
const AWS = require('aws-sdk');

// Configure AWS SDK with your credentials and S3 bucket information
AWS.config.update({
  accessKeyId: 'AKIAXUD4YKDH74GLUH5Y',
  secretAccessKey: 'jCQbmbfNGiQ3VCI8gYf3H9qi5UiGfBzDUbwEN1Eg',
  region: 'ap-south-1', // Replace with your desired region
});

const s3 = new AWS.S3();

export async function uploadSvgAsImageToS3(svgElement, file_name = "family_tree.svg", bucketName = 'prod-media-file') {
  try {
    console.log("uploadSvgAsImageToS3 svg utils")
    const dataUrl = await toPng(svgElement);
    console.log("file_name",file_name)

    if (dataUrl) {
      // Convert data URL to a Blob
      const arrayBuffer = new ArrayBuffer(dataUrl.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < dataUrl.length; i++) {
        uint8Array[i] = dataUrl.charCodeAt(i);
      }

      const blob = new Blob([arrayBuffer], { type: 'image/png' });

      // Define the S3 parameters
      const params = {
        Bucket: bucketName,
        Key: file_name,
        Body: blob,
      };

      // Upload the image to S3
      const data = await s3.upload(params).promise();
      console.log('Uploaded to S3:', data.Location);
    } else {
      console.error('Image data URL is empty.');
    }
  } catch (error) {
    console.error('Error uploading image to S3:', error);
  }
}

// Function to zoom an SVG element
export function zoom(svgElement, increment) {
  const currentTransform = svgElement.getAttribute('transform');
  const currentScale = parseFloat(currentTransform.match(/scale\(([\d.]+)\)/)[1]);
  const newScale = currentScale + increment;

  if (newScale > 0.15 && newScale < 3) {
    const newTransform = currentTransform.replace(/scale\([\d.]+\)/, `scale(${newScale})`);
    svgElement.setAttribute('transform', newTransform);
  }
}

// Function to download an SVG element as an image
// export function downloadSvgAsImage(svgElement, file_name = 'familytree.svg',family_name) {
//   svgElement.innerHTML='<div class="n-logo" style="position: relative;top:30px;left:-630px;"><a class="logo" href="" style="color: black; text-decoration: none;"><img src="/static/media/full_logo.34ed546de6fa54f2109d91c4d5710f46.svg" width="150" height="50" alt="logo"></a></div>  <div class="familyName" style="font-size:x-large"><u><i>'+family_name+'</i></u></div>'+svgElement.innerHTML

//   toSvg(svgElement)
//     .then(function (dataUrl) {
//       if (dataUrl) {
//         console.log(dataUrl)
//         const a = document.createElement('a');
//         a.href = dataUrl;
//         a.download = file_name;
//         // window.location.reload()
//         a.click();

//       } else {
//         console.error('Image data URL is empty.');
//       }
//     })
//     .catch(function (error) {
//       console.error('Image capture error:', error);
//     });
// }
export function downloadSvgAsImage(svgElement, file_name = 'familytree.svg', family_name) {
  // Add watermark pattern and background
  const watermark = `
    <defs>
      <pattern id="watermarkPattern" x="0" y="0" width="200" height="50" patternUnits="userSpaceOnUse">
        <text x="100" y="25" text-anchor="middle" dominant-baseline="middle" font-size="18" fill="rgba(0, 0, 0, 0.2)">memyfolks.com</text>
      </pattern>
    </defs>
    <rect x="0" y="0" width="100%" height="100%" fill="url(#watermarkPattern)" />
  `;

  const originalContent = svgElement.innerHTML;

  svgElement.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg"  width="100%" height="100%">
      ${watermark}
      <g>
        <foreignObject x="0" y="0" width="100%" height="100%">
          <div xmlns="http://www.w3.org/1999/xhtml">
            <div class="n-logo" style="position: relative;top:30px;left:-630px;">
              <a class="logo" href="" style="color: black; text-decoration: none;">
                <img src="/static/media/full_logo.34ed546de6fa54f2109d91c4d5710f46.svg" width="150" height="50" alt="logo">
              </a>
            </div>
            <div class="familyName" style="font-size:x-large">
              <u><i>${family_name}</i></u>
            </div>
          </div>
        </foreignObject>
        ${originalContent}
      </g>
    </svg>
  `;

  toSvg(svgElement)
    .then(function (dataUrl) {
      if (dataUrl) {
        console.log(dataUrl);
        const a = document.createElement('a');
        a.href = dataUrl;
        a.download = file_name;
        window.location.reload()
        a.click();
      } else {
        console.error('Image data URL is empty.');
      }
    })
    .catch(function (error) {
      console.error('Image capture error:', error);
    });
}



// Your other functions (handleLabs, Refresh) remain unchanged
export function handleLabs() {
  // Implement your Labs logic here
}

export function Refresh() {
  // Implement your refresh logic here
}
